import {CookieManagementConfig} from "./cookie-management-config.interface";

export const cookieManagementDefaultConfig: CookieManagementConfig = {
    cookieName: 'COOKIES_ACCEPTED',
    cookieDomain: '.csob.sk',
    cookiePath: '/',
    cookieSameSite: 'Lax',
    cookieSecure: false,
    cookieExpirationDays: 365,
    excludeFrom: '\/cookies$',
    showConsent: true,
    majorVersion: 0,
    minorVersion: 0,
    resources: {}
}